import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import Footer from '../../Components/Menu/Footer';
import { COR_PRINCIPAL_DEFAULT } from '../../constants';

const LinkPagamentoPago: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        background: `linear-gradient(
          145deg,
          ${alpha(theme.palette.grey[100], 0.9)} 0%,
          ${alpha(theme.palette.primary.light, 0.05)} 100%
        )`,
        position: 'relative',
        overflow: 'hidden',
        py: { xs: 4, md: 8 }
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          height: 280,
          background: `linear-gradient(135deg, ${COR_PRINCIPAL_DEFAULT} 0%, ${alpha(
            COR_PRINCIPAL_DEFAULT,
            0.85
          )} 100%)`,
          clipPath: 'polygon(0 0, 100% 0, 100% 65%, 0 100%)',
          zIndex: 0
        }}
      />

      <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 1 }}>
        <Paper
          elevation={6}
          sx={{
            borderRadius: 4,
            textAlign: 'center',
            p: { xs: 4, md: 6 },
            backdropFilter: 'blur(4px)'
          }}
        >
          <Typography variant="h4" component="h1" fontWeight={700} gutterBottom>
            Cobrança já foi paga!
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Esta cobrança já foi quitada anteriormente.
          </Typography>

          <Box
            component="img"
            src="/undraw_done_i0ak.svg"
            alt="Pagamento realizado"
            sx={{
              width: { xs: 180, sm: 220, md: 250 },
              maxWidth: '100%',
              height: 'auto',
              mx: 'auto'
            }}
          />
        </Paper>

        <Footer backgroundColor="transparent" />
      </Container>
    </Box>
  );
};

export default LinkPagamentoPago;
